import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step146420Meta extends BaseModel {
  /**
   * @var {?boolean}
   */
  hasPreArrangement;

  constructor(model = {}) {
    super();
    this.hasPreArrangement = model.hasPreArrangement;
  }
}
